import React, { useState,useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { var_api } from '../constant.js';
import "./rawMaterial-master.css";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { Tooltip } from 'reactstrap';

function RawMaterial(){
    const history = useHistory();
    const shopName= localStorage.getItem('shopName');
    const [item_name,setitem_name] = useState("");
    const [stock_code,setstock_code] =  useState("");
    const [rawItems, setRawItems] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [ searchQuery,setSearchQuery] = useState('');
    const [isEdit, setisedit] = useState(false);
    const [ postloading,setPostLoading ] = useState(false);
    const [updatedMaterial, setUpdatdeMaterial] = useState({
      id:null,
      item_name:"",
      stock_code:""
    });
    const [show, setShow] = useState(false);
    const [puttooltipOpen, setPutToolTipOpen] = useState([]);
    const [deletetooltipOpen, setDeleteToolTipOpen] = useState([]);

    //redirect to home page
    const handleHome = () =>{
      history.push('/home')
    }

    const togglePutTooltip = (index) => {
      const putTooltipOpen = [...puttooltipOpen];
      putTooltipOpen[index] = !putTooltipOpen[index];
      setPutToolTipOpen(putTooltipOpen);
    };
    
    
    const toggleDeleteTooltip = (index) => {
      const deleteTooltipOpen = [...deletetooltipOpen];
      deleteTooltipOpen[index] = !deleteTooltipOpen[index];
      setDeleteToolTipOpen(deleteTooltipOpen);
    };

    //list the catgories in select
    useEffect(() => {
        fetchItems();
    
    }, []);


//fetch the uom details
    const fetchItems = async () => {
        setLoading(true);

        const shopId = localStorage.getItem('shopId');
       try {
        const response = await axios.get(`${var_api}/api/raw-items/get-items/${shopId} `);
        const use = response.data
      setRawItems(use);
      
      console.log("categories",rawItems)
      setLoading(false);
      }catch (error) {
        console.log('Error fetching data:', error);
        
        }
      };

 
       // Function to convert string to camelCase
  const capitalizeEachWord = (str) => {
    return str.toLowerCase().replace(/(^|\s)\S/g, function (match) {
      return match.toUpperCase();
    });
  };

   //post the form data
    const Submit = async (e) => {
      e.preventDefault();
      setPostLoading(true);

      try {
        const response = await axios.post(`${var_api}/api/raw-items/post`, {
            item_name: capitalizeEachWord(item_name), 
            stock_code: stock_code,
            shop_id: localStorage.getItem('shopId')
        });
        console.log("response",response)
    
        if (response.status === 200) {
          Swal.fire({
            icon:"success",
            text:"Raw Items Created Successfully",
            confirmButtonColor:"#007500"
          })
          setstock_code(" ");
          setitem_name(" ");
          setPostLoading(false);
          fetchItems();
          console.log('Data inserted successfully.')
      } 
      } catch (error) {
        
        Swal.fire({
            icon:"error",
            text:`Item Name or Stock Code Already Exist`.toUpperCase(),
            confirmButtonColor:"#dc3545"
          })
          setPostLoading(false);
        console.error('Error:',error);
        // Handle error scenario as needed
      }
    };

    const handleToReset = () => {
        setstock_code(" ");
        setitem_name(" "); 
    }



      //get the value in search and set the setstate
      const handleSearchInput = (e) => {
        setSearchQuery(e.target.value)
        };


         //search the transaction data
      const filteredItems = rawItems.filter((order) => {
        const searchLower = searchQuery.toLowerCase();
        return (
          (order.item_name && order.item_name.toString().toLowerCase().includes(searchLower)) ||
          (order.stock_code && order.stock_code.toString().toLowerCase().includes(searchLower))
          
        );
      });

      //to open the form for slot updation 
    const handleEditItem = async (data) => {
      setisedit(true);
      setUpdatdeMaterial({
        id: data.id,
        item_name: data.item_name,
        stock_code: data.stock_code
      })
        // const { value: formValues } = await Swal.fire({
        //     title: 'Update Currrency',
        //     html: `
        //      <label class="swalLa">Item Name</label>
        //      <br/>
        //       <input id="swal-input1" class="swal2-input fin" name="item_name" placeholder="Item Name" value="${data.item_name || ''}">
        //       <br/>
        //       <br/>
        //       <label class="swalLa">Stock Code</label>
        //       <input id="swal-input2" class="swal2-input fin" name="stock_code" placeholder="Stock Code" value="${data.stock_code || ''}">
             
        //     `,
        //     focusConfirm: false,
        //     showCancelButton: true,
        //     confirmButtonColor: '#007500',
        //     confirmButtonText: 'Submit',
        //     preConfirm: () => {
        //       return new Promise(async (resolve) => {
        //         const input1 = document.getElementById('swal-input1').value;
        //         const input2 = document.getElementById('swal-input2').value;
        
        //         if (!input1 || !input2) {
        //           Swal.showValidationMessage('Please fill in all the required fields');
        //           resolve(null);
        //         } else {

        //           const requestData = {
        //             item_name: input1|| data.item_name,
        //             stock_code: input2 || data.stock_code
        //           };
        
        //           try {
        //             // Make a PUT request to update the UOM
        //             const response = await axios.put(${var_api}/api/raw-items/put/${data.id}, requestData, {
        //               headers: {
        //                 'Content-Type': ' application/json', 
        //               },
        //             });
        
        //             if (response.status === 200) {
        //                 fetchItems();
        //               // Category updated successfully
        //               Swal.fire({
        //                 icon: 'success',
        //                 text: 'Raw Items updated successfully',
        //                 confirmButtonColor: '#007500',
        //               });
        //             } else {
        //               Swal.fire({
        //                 icon: 'error',
        //                 text: 'Failed to update Raw Items',
        //                 confirmButtonColor: '#007500',
        //               });
        //             }
        //           } catch (error) {
        //             console.error('Error updating Raw Items:', error);
        //             Swal.fire('Error', 'Failed to update Raw Items. Please try again.', 'error');
        //           }
        
        //           resolve(requestData);
        //         }
        //       });
        //     },
        //   });
      };


       //delete method for remove UOM
     const handleDeleteItem = (id,item) => {
      setUpdatdeMaterial({item_name:item,id:id});
      setShow(true);
       
      }

       //handle to reset the update form
    const handleResetShop = () => {
      setUpdatdeMaterial({
        item_name:"",
        stock_code:""
      })
    }

   

    const handleUpdateMaterial = async() => {
                 const requestData = {
                    item_name: capitalizeEachWord(updatedMaterial.item_name),
                    stock_code: updatedMaterial.stock_code
                  };
        
                  try {
                    // Make a PUT request to update the UOM
                    const response = await axios.put(`${var_api}/api/raw-items/put/${updatedMaterial.id}`, requestData, {
                      headers: {
                        'Content-Type': ' application/json', 
                      },
                    });
        
                    if (response.status === 200) {
                        fetchItems();
                        setisedit(false);
                        setUpdatdeMaterial({
                          id:null,
                          item_name:"",
                          stock_code:""
                        })
                      // Category updated successfully
                      Swal.fire({
                        icon: 'success',
                        text: 'Raw Items updated successfully',
                        confirmButtonColor: '#007500',
                      });
                    } else {
                      Swal.fire({
                        icon: 'error',
                        text: 'Failed to update Raw Items',
                        confirmButtonColor: '#007500',
                      });
                    }
                  } catch (error) {
                    console.error('Error updating Raw Items:', error);
                    Swal.fire('Error', 'Failed to update Raw Items. Please try again.', 'error');
                  }
    }


    const handleDeleteMaterial = () => {
       axios
        .delete(`${var_api}/api/raw-items/item-delete/${updatedMaterial.id}`)
        .then((response) => {
          if (response.status === 200) {
            fetchItems();
            setShow(false);
            setUpdatdeMaterial({
              id:null,
              item_name:"",
              stock_code:""
            })
            Swal.fire("success","Raw Items Removed Successfully!","success")
            // Perform any other actions you need on success
          } else if (response.status === 404) {
            console.log('Raw Items not found');
            Swal.fire("error","Raw Items not found!","error")
          }
        })
        .catch((error) => {
          console.error('Error executing the request:', error);
          Swal.fire("error","Failed to Remove Raw Items!","error")
          // Handle the error as needed
        });
    }


    return(
        <>
        <div className='whole' style={{backgroundColor:"white"}}>
            <div class="split left">
                <div class="centered">
                  <br/>
                  <br/>
                    <h3 className='ushe'>Create Raw material</h3>
                    <br/>
                    <div style={{marginLeft:"12px",padding:"12px"}}>

                    <form onSubmit={Submit}>
            <div className='mb-5'>
            <lable style={{fontWeight:"bold",fontSize:"14px",marginLeft:"30px"}}>Item Name</lable>
            <br/>
            <input  className="form-input" type='text' name='item_name' placeholder='enter item name'
             required
             value={item_name}
             onChange={(e) => setitem_name(e.target.value)}/>
            </div>
            <br/>
            <div className='mb-5'>
            <lable style={{fontWeight:"bold",fontSize:"14px",marginLeft:"30px"}}>Stock Code</lable>
            <input  className="form-input" type='text' name='stock_code' placeholder='enter stock code'
            required
             value={stock_code}
             onChange={(e) => setstock_code(e.target.value)}/>
            </div>
           
            <br/>
            <br/>
            <button className='btn btn-success' style={{float:"right",marginLeft:"5px"}} disabled={postloading}>{postloading ? (
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
          />
        ) : (
          'Submit'
        )}</button> {' '}
            </form>
            
            {' '}<button className='btn btn-secondary' style={{float:"right"}}  onClick={handleToReset} >Reset</button> {' '}
                       
                        
                    </div>
                   
                </div>
            </div>

            <div class="split right">
            <nav className="navbar" 
            style={{boxShadow: "0px 0px 1px 0px black",backgroundColor:"green",border:"none",padding:"5px",height:"50px",width:"1065px",position:"relative",top:"-10px"}} >
              <div style={{ display: "flex"}}>
                <h4 style={{ fontFamily: "cursive", fontWeight: "bolder",marginLeft: "250px", color: "white" }}>{ shopName }</h4>
                <button className="btn" onClick={handleHome} style={{marginLeft:"200px",backgroundColor:"white",color:"green"}}
         ><i class="bi bi-house"></i> Go to Home</button>
              </div>
      </nav>
      <div style={{border:"none",padding:"20px",width:"1020px",height:"640px",margin:"auto",borderRadius:"15px",backgroundColor:"white",boxShadow:" rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px"}}>
      
      <div>
        
      <input class="form-control" type="Search" placeholder="Search" id="example-search-input" 
      style={{width:"230px",borderRadius:"25px",border:"1px solid black",float:"right"}} onChange={handleSearchInput}/>
      {/* <h3 style={{textAlign:"center",fontFamily:"cursive",fontWeight:"bolder",textDecoration:"underline"}}>Raw Materials List</h3> */}
      <br/>
      <br/>
      <br/>
     <div className="table-container" style={{ height:"500px", overflowX: 'auto', overflowY: 'scroll' }}>
  <table class="table table-hover small-first-col" style={{border:"none",borderColor:"grey",width:"90%",margin:"auto"}}>
  <thead>
    <tr style={{fontWeight:"bolder"}}>
    <th scope="col">S.No</th>
      <th scope="col">Item Name</th>
      <th scope="col">Stock Code</th>
      <th scope="col">Action</th>
    </tr>
  </thead>
  <tbody class="body-half-screen">
   {filteredItems.length > 0 ? (
   filteredItems.map((data,index) =>(

    <tr>
       <th scope="row">{index + 1}</th>
      <td style={{ fontSize:"15px"}}>{data.item_name}</td>
      <td style={{fontSize:"15px"}}>{data.stock_code}</td>
      <td>
      <Tooltip
        isOpen={puttooltipOpen[index]} // Use tooltip state based on index
        target={`putButton${index}`} // Specify the target ID of the button
        toggle={() => togglePutTooltip(index)}
        placement='left'
      >
          Edit Material
        </Tooltip>
      <i class="bi bi-pencil-square" id={`putButton${index}`} onClick={() => {handleEditItem(data); togglePutTooltip(index);}}  style={{fontSize:"20px",color:"rgb(9, 97, 9)"}}></i>{' '}
      <Tooltip
        isOpen={deletetooltipOpen[index]} // Use tooltip state based on index
        target={`deleteButton${index}`} // Specify the target ID of the button
        toggle={() => toggleDeleteTooltip(index)}
        placement='right'
      >
          Delete Material
        </Tooltip>
      <i class="bi bi-trash" id={`deleteButton${index}`} onClick={() => {handleDeleteItem(data.id,data.item_name); toggleDeleteTooltip(index); }}  style={{fontSize:"21px",color:"rgb(175, 2, 2)"}}></i>
      </td>
    </tr>
   ))
   ) : (
    <tr>
      <td colSpan="5" style={{ textAlign: "center" }}>
        No Item Found
      </td>
    </tr>
   )}
 

   </tbody>

</table>

      </div>
<br/>
<br/>


        </div>
      
      </div>
            </div>


            
<Modal
        show={isEdit}
        onHide={()=>setisedit(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title> Update Raw Material </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={handleUpdateMaterial}>
          <div class="row">
            <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Item Name</label>
              <input type="text" class="form-control" placeholder="enter item name" id="input1"  name="item_name"  value={updatedMaterial.item_name}  onChange={(e) => setUpdatdeMaterial({...updatedMaterial, item_name:e.target.value})} style={{borderRadius:"12px"}} required/>
            </div>
            <div class="col">
              <label for="input2" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Stock Code</label>
              <input type="text" class="form-control" placeholder="enter stock code" id="input2" name="stock_code" value={updatedMaterial.stock_code} onChange={(e) => setUpdatdeMaterial({...updatedMaterial, stock_code:e.target.value})} style={{borderRadius:"12px"}} required/>
            </div>
          </div>
          <br/>
         
          <button className="btn btn-success" style={{float:"right",margin:"5px",borderRadius:"15px"}}>Update</button>
          </form>
          <button className="btn btn-danger" onClick={()=>setisedit(false)} style={{borderRadius:"15px",float:"right",marginTop:"-1px"}}>Cancel</button>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>


            <Modal
        show={show}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(6, 105, 16, 0.367)",padding:"22px"}}>
          {/* <Modal.Title>confirmation</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px",backgroundColor:"white"}}>
         <h4 style={{fontFamily:"monospace",fontWeight:"bolder",textAlign:"center"}}>CONFIRM!</h4>
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure want to Delete Item{" "}
          <span style={{color:"red",textTransform:"uppercase",fontSize:"22px"}}>{updatedMaterial.item_name}</span> ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={()=>setShow(false)}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDeleteMaterial}>
            Confirm
          </Button>
        </Modal.Body>
      </Modal> 
        </div>

       
        </>

    )
}



export default RawMaterial;